<div class="p-6 h-full overflow-y-auto">
  <div class="max-w-4xl mx-auto space-y-6">
    
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-2xl font-bold tracking-tight text-on-surface">アラート基準値設定</h1>
        <p class="text-on-surface-variant mt-1">現場ごとの各センサーのアラート判定基準を設定します。</p>
      </div>
      <div class="flex gap-2">
        <a matButton routerLink="/sites/manage">キャンセル</a>
        <button matButton="tonal" (click)="save()" [disabled]="isLoading() || form.invalid">
          保存
        </button>
      </div>
    </div>

    <mat-card class="bg-primary-container shadow-none! border border-outline-variant">
      <mat-card-header>
        <mat-card-title class="text-lg">通知先メールアドレス</mat-card-title>
      </mat-card-header>
      <mat-card-content class="pt-4">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>メールアドレス</mat-label>
          <mat-chip-grid #emailChipGrid aria-label="通知先メールアドレス">
            @for (email of emails(); track email) {
              <mat-chip-row (removed)="removeEmail(email)">
                {{ email }}
                <button matChipRemove type="button" [attr.aria-label]="email + ' を削除'">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            placeholder="例: alert@example.com"
            [matChipInputFor]="emailChipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
            (matChipInputTokenEnd)="addEmail($event)"
          >
        </mat-form-field>
        @if (emailError()) {
          <p class="mt-1 text-sm text-error" aria-live="polite">{{ emailError() }}</p>
        }
      </mat-card-content>
    </mat-card>

    <form [formGroup]="form" class="space-y-6">
      
      <!-- 騒音（NOISE）アラート設定 -->
      <mat-card class="bg-primary-container shadow-none! border border-outline-variant">
        <mat-card-header>
          <mat-card-title class="text-lg">騒音センサー (NOISE)</mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-4" formGroupName="noise">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>騒音基準値 (dB)</mat-label>
              <input matInput type="number" formControlName="noiseThreshold" placeholder="例: 85">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>振動基準値 (dB)</mat-label>
              <input matInput type="number" formControlName="vibrationThreshold" placeholder="例: 70">
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- pH アラート設定 -->
      <mat-card class="bg-primary-container shadow-none! border border-outline-variant">
        <mat-card-header>
          <mat-card-title class="text-lg">pHセンサー</mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-4" formGroupName="ph">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>下限閾値</mat-label>
              <input matInput type="number" formControlName="minThreshold" placeholder="例: 5.8" step="0.1">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>上限閾値</mat-label>
              <input matInput type="number" formControlName="maxThreshold" placeholder="例: 8.6" step="0.1">
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

      <!-- 傾斜（TILT）アラート設定 -->
      <mat-card class="bg-primary-container shadow-none! border border-outline-variant">
        <mat-card-header>
          <mat-card-title class="text-lg">傾斜センサー (TILT)</mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-4" formGroupName="tilt">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>絶対変位の管理基準値</mat-label>
              <input matInput type="number" formControlName="absoluteDisplacementThreshold" placeholder="例: 1.0" step="0.1">
            </mat-form-field>
            <mat-form-field appearance="outline" class="w-full">
              <mat-label>時間変位の管理基準値（1時間あたり）</mat-label>
              <input matInput type="number" formControlName="temporalDisplacementThreshold" placeholder="例: 0.5" step="0.1">
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

    </form>

  </div>
</div>
